import { useEffect, useState } from 'react';

export const COOKIE_WARNING_VISIBLE_CLASS = 'cookie-warning-visible';
const COOKIE_WARNING_VISIBILITY_EVENT = 'cookie-warning-visibility';

export const setCookieWarningVisible = (visible: boolean): void => {
  document.body.classList.toggle(COOKIE_WARNING_VISIBLE_CLASS, visible);
  window.dispatchEvent(
    new CustomEvent(COOKIE_WARNING_VISIBILITY_EVENT, { detail: visible })
  );
};

export const useIsCookieWarningVisible = (): boolean => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const sync = (): void => {
      setIsVisible(
        document.body.classList.contains(COOKIE_WARNING_VISIBLE_CLASS)
      );
    };

    sync();
    window.addEventListener(COOKIE_WARNING_VISIBILITY_EVENT, sync);
    return () => {
      window.removeEventListener(COOKIE_WARNING_VISIBILITY_EVENT, sync);
    };
  }, []);

  return isVisible;
};
